@if (data$ | async; as data) {
  <cx-media [loading]="'lazy'" [container]="data.media" [ngClass]="pageClass"></cx-media>
}
